// 🔧 social_seeder.js
// ✅ Purpose: Seeds Social Engine demo data into Firestore
// ✅ Features:
// - Coordinates persistence of social draft posts
// - Calls repository layer only
// - No Firestore logic here
// - Returns standardized results to Builder
// - Fully block-commented for clarity and future devs

import { saveSocialPosts } from "./social_repository";

export const seedSocial = async ({
  demoContext,
  socialPlan,
} = {}) => {
  console.log("🌱 Social Seeder started.");

  if (!socialPlan) {
    throw new Error("Social Seeder requires socialPlan.");
  }

  const results = await saveSocialPosts({
    demoContext,
    posts: socialPlan.posts || [],
  });

  console.log("✅ Social Seeder completed.", {
    posts: results.posts.length,
  });

  return results;
};